import React from 'react'
import { MiniCardProps } from './types'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { Card } from '@toasttab/shared/src/utils/craftUtils'

const MiniCard = ({
  heading,
  description,
  accentColor,
  accentPosition,
  backgroundColor,
  borderColor,
  elevation
}: MiniCardProps) => {
  return (
    <div
      className={`${backgroundColor} relative overflow-hidden border ${Card.borderColor(
        borderColor
      )} ${Card.elevation(elevation)} rounded-md`}
      data-testid='minicard'
    >
      {accentPosition == 'top' && (
        <div
          className={`minicard-accent relative h-1 rounded-tl-[10px] rounded-tr-[10px] ${Card.accentColor(
            accentColor
          )}`}
          data-testid='accent'
        />
      )}
      <div className={`px-4 py-8`}>
        <Typography variation='h5' as='h5' classes='text-default mb-0.5'>
          {heading}
        </Typography>
        <p className='text-gray-100' data-testid='description'>
          {description}
        </p>
      </div>
      {accentPosition == 'bottom' && (
        <div
          className={`relative h-1 rounded-bl-[10px] rounded-br-[10px] ${Card.accentColor(
            accentColor
          )}`}
          data-testid='accent'
        />
      )}
    </div>
  )
}

export default MiniCard
